import MainLayout from './layouts/MainLayout.vue';
import Error404 from './pages/error-404.vue';
import Error403 from './pages/error-403.vue';

export default {
  path: '/errors',
  component: MainLayout,
  children: [{
    path: '404',
    component: Error404,
    name: 'error-404',
  }, {
    path: '403',
    component: Error403,
    name: 'error-403',
  }],
};
